// extracted by mini-css-extract-plugin
export default {"container":"Ri-z","blurb":"Si-z","links":"Ti-z"};